<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<h4>{{translate(locale.editClient)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="!loaded">
			<md-card>
				<md-card-content>
					<loading />
				</md-card-content>
			</md-card>
		</div>

		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="loaded">
			<md-card>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-100 text-right">
									<span class="late">{{translate(locale.required)}}</span>
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<md-field>
										<label>{{translate(locale.clientName)}} *</label>
										<md-input type="text" v-model="client.name"></md-input>
									</md-field>
								</div>
							</div>
						</div>
						<div class="md-layout-item md-size-100 text-right">
							<span v-for="e in errors" style="color: red">* {{translate(e)}}<br></span>
						</div>
						<div
							class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
							<md-button class="md-raised md-primary"
								@click="update()">{{translate(locale.editClient)}}</md-button>
						</div>
					</div>

				</md-card-content>
			</md-card>
		</div>
	</div>

	</div>

</template>

<script>
	export default {
		created() {
			this.getClient();
		},
		data() {
			return {
				loaded: false,
				client: {
					name: ""
				},
				errors: []
			}
		},
		methods: {
			getClient() {
				this.$http.get(this.config.api + "/admin/client/get/" + this.$route.params.hash).then(data => {
					let client = data.body.data.client;

					this.client.name = client.name;

					this.loaded = true;
				});
			},
			update() {

				if (!this.checkValidation()) {
					this.$notification.notify({ message: "Please fill in all required information.||សូមបំពេញព័ត៌មានឱ្យបានគ្រប់គ្រាន់។", icon: 'error', type: 'danger' });
					return;
				}

				this.$http.post(this.config.api + "/admin/client/update", {
					hash: this.$route.params.hash,
					client: this.client
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have created a system client successfully.||អ្នកបានបង្កើតប្រព័ន្ធបុត្រសម្ព័ន្ធដោយជោគជ័យ។",
							icon: 'check_circle',
							type: 'success'
						});

						this.$router.push("/system_clients/detail/" + this.$route.params.hash);
					}
				})
			},
			checkValidation() {
				this.errors = [];

				if (String(this.client.name).length < 3) this.errors.push("Please fill in Name.||សូមបំពេញឈ្មោះប្រព័ន្ធបុត្រសម្ព័ន្ធ។");

				if (this.errors.length == 0) return true;
				else return false;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/Clients/Edit.vue